<div class="flex flex-col gap-2">
  <span *ngIf="label" [class]="labelClass">
    {{ label }}
  </span>
  <ng-content></ng-content>
</div>
